import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ElementInfoAdapter from '@src/slide/application/service/edit-action-services/element-info';
import { GroupUIEdge } from '../../element-types/group-element/constant';
import { transformOfFlip } from '../../common';
import { matrixForFrame, matrixRotate, multiplyMatrix } from '@src/slide/infrastructure/module/independent/graphic';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { enumerateGroup } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { IRotateElementHandler } from '@src/slide/application/service/edit-action-services/rotate-element-handler/rotate-element-handler.interface';
import { IDragElementHandler } from '@src/slide/application/service/edit-action-services/drag-element-handler/drag-element-handler.interface';
import { IResizeElementHandler } from '@src/slide/application/service/edit-action-services/resize-element-handler/resize-element-handler.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { PropertyEditorShowAction } from '@src/js/constant';

const DEFALUT_ROTATE = 0;
export default class SelectedElementWrapperUtil {
    public static frameInfoForOuter(elementModel: IElementBaseModel, isOperation) {
        const isGroupChildren = elementModel?.parent?.type === UIModelType.GROUP;
        if (isGroupChildren) {
            return elementModel.getFrame?.()
                .frameOnSlide(elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame), isOperation);
        }
        // const isSmartArtChildren = elementModel?.parent?.type === UIModelType.SMART_ART;
        // if (isSmartArtChildren) {
        //     return elementModel.getFrame?.()
        //         .frameOnSlide(elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame), isOperation);
        // }
        return elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
    }

    /**
     * 除了自己层的flip，由外到内的rotate和flip信息的transform matrix值
     * @param elementModel
     * @param isOperation
     */
    public static transformForOuter(elementModel: IElementBaseModel, isOperation?) {
        let transformArray = [1, 0, 0, 1, 0, 0];
        const isGroupChildren = elementModel?.parent?.type === UIModelType.GROUP;
        let currentMatrix;
        let frame = elementModel.getFrame?.().getFrameInfo(isOperation);
        if (frame?.rotate) {
            transformArray = multiplyMatrix(matrixRotate(frame.rotate), transformArray);
        }
        if (isGroupChildren) {
            enumerateGroup(elementModel, (groupModel) => {
                frame = groupModel.getFrame?.().getFrameInfo(isOperation);
                currentMatrix = matrixForFrame(frame);
                if (currentMatrix) {
                    transformArray = multiplyMatrix(currentMatrix, transformArray);
                }
            });
        }
        // TODO: YOUGETANG 补充对应逻辑（children）

        return `matrix(${transformArray[0]}, ${transformArray[1]},
            ${transformArray[2]}, ${transformArray[3]},
            ${transformArray[4]}, ${transformArray[5]})`;
    }

    public static frameInfoForInner(elementModel: IElementBaseModel) {
        return elementModel.getFrame?.().getFrameInfo(false);
    }

    public static relativeInfoForInner(elementModel: IElementBaseModel) {
        const realFrameOnSlide = elementModel.getFrame?.().frameOnSlide();
        const isGroupChildren = elementModel?.parent?.type === UIModelType.GROUP;
        let relativeFlipV = 0;
        let relativeFlipH = 0;
        let relativeRotate = 0;
        if (isGroupChildren) {
            const elementStyle = elementModel.props.style;
            relativeFlipH = realFrameOnSlide.flipH ?? relativeFlipH;
            if (elementStyle.flipH === 1) {
                relativeFlipH = (relativeFlipH === 0 ? 1 : 0);
            }
            relativeFlipV = realFrameOnSlide.flipV ?? relativeFlipV;
            if (elementStyle.flipV === 1) {
                relativeFlipV = (relativeFlipV === 0 ? 1 : 0);
            }
            const elementRotate = elementStyle.rotate ?? DEFALUT_ROTATE;
            const realFrameOnSlideRotate = realFrameOnSlide.rotate ?? DEFALUT_ROTATE;
            relativeRotate = (realFrameOnSlideRotate + 360 - elementRotate) % 360;
        }
        return {
            relativeFlipH,
            relativeFlipV,
            relativeRotate,
        };
    }

    public static commonPropsForCanvasElement(elementModel: IElementBaseModel, scale) {
        const frameInfo = SelectedElementWrapperUtil.frameInfoForOuter(elementModel, true);
        return {
            component: elementModel,
            getSize: () => ElementInfoAdapter.sizeInfo(elementModel),
            getFlip: () => ElementInfoAdapter.flipInfo(elementModel),
            selectable: true,
            isSelected: true,
            onResize: this.getResizeElementHandler()?.handleResize,
            onResizeStart: (e, resizeMode: string) => {
                this.getResizeElementHandler()?.handleResizeStart(elementModel, e, scale, resizeMode);
            },
            onResizeStop: this.getResizeElementHandler()?.handleResizeStop,
            onRotate: this.getRotateElementHandler()?.handleRotate,
            onRotateStart: (e) => {
                this.getRotateElementHandler()?.handleRotateStart(elementModel, scale, e);
            },
            onRotateStop: this.getRotateElementHandler()?.handleRotateStop,
            onDragStart: this.getDragElementHandler()?.handleDragStart.bind(this.getDragElementHandler(), elementModel),
            onDrag: this.getDragElementHandler()?.handleDrag,
            onDragStop: this.getDragElementHandler()?.handleDragStop,
            onBorderDoubleClick: SelectedElementWrapperUtil
                .commonBorderDoubleClick.bind(SelectedElementWrapperUtil, elementModel),
            onBorderMouseUp: this.handleBorderMouseUp,
            style: {
                transform: transformOfFlip(frameInfo),
                width: frameInfo.width,
                height: frameInfo.height,
                position: 'absolute',
            },
        };
    }

    public static frameForRootGroup(elementModel: IElementBaseModel, currentFrame) {
        if (elementModel.type === UIModelType.GROUP
            // @ts-ignore
            && elementModel.isRootGroup) {
            return {
                left: currentFrame.left - GroupUIEdge,
                top: currentFrame.top - GroupUIEdge,
                width: currentFrame.width + (GroupUIEdge * 2),
                height: currentFrame.height + (GroupUIEdge * 2),
            };
        }
        return {};
    }

    /**
     * 检查控制点是否相同
     * @param newControlValues
     * @param oldControlValues
     */
    public static checkControlValuesSame = (newControlValues, oldControlValues) => {
        if (newControlValues
            && newControlValues.length > 0
            && oldControlValues
            && oldControlValues.length > 0
            && newControlValues.length === oldControlValues.length
        ) {
            for (let i = 0; i < newControlValues.length; i++) {
                if (newControlValues[i] !== oldControlValues[i]) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };

    /**
     * 通用边框选中事件处理逻辑，表格除外
     * @param elementModel
     * @param e
     */
    public static commonBorderDoubleClick(elementModel: IElementBaseModel, e): void {
        e?.stopPropagation();
        const editable = this.getUserPriviledgeService().pptEditorState === PPTEditorStateType.EDITABLE;
        if (editable) {
            this.getRightSideBarManager()?.setPropertyEditorShowAction(PropertyEditorShowAction.DOUBLE_CLICK_TOOGLE);
            (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
                .viewableServiceLayer.rightSideBarService.hide();
        }
    }

    private static getUserPriviledgeService(): IUserPriviledgeService {
        return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
            .viewableServiceLayer.userPriviledgeService;
    }

    private static getRightSideBarManager() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.rightSideBarManager;
    }

    private static getRotateElementHandler(): IRotateElementHandler | undefined {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appServices.editableServiceLayer?.rotateElementHandler;
    }

    private static getDragElementHandler(): IDragElementHandler | undefined {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appServices.editableServiceLayer?.dragElementHandler;
    }

    private static getResizeElementHandler(): IResizeElementHandler | undefined {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appServices.editableServiceLayer?.resizeElementHandler;
    }

    private static handleBorderMouseUp() {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        const { animBrushManager, formatBrushManager } = appServices.editableServiceLayer || {};
        if (animBrushManager?.animBrushState) {
            animBrushManager?.onElementSelectionMouseUp();
        } else if (formatBrushManager?.formatBrushState) {
            formatBrushManager?.onElementSelectionMouseUp();
        }
    }
}
